import React from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";

import { TIME_SUMMARY_COLUMNS } from "./columns";

const TimeSummaryItemHeader = ({ customer, numCalls, callTypes, children }) => (
  <div className="time-summary-item-header">
    <h4>{customer}</h4>
    <span>{numCalls} calls</span>
    {Object.keys(callTypes).map((k, i) => (
      <span key={i}>
        {k}:&nbsp;{callTypes[k]} hrs
      </span>
    ))}
    {children}
  </div>
);
TimeSummaryItemHeader.propTypes = {
  customer: PropTypes.string,
  numCalls: PropTypes.number,
  callTypes: PropTypes.object,
  children: PropTypes.node
};
const TimeSummaryItem = ({ customer, calls = [], callTypes = {} }) => (
  <div className="content-wrapper time-summary-item" id={customer}>
    <TimeSummaryItemHeader
      customer={customer}
      numCalls={calls.length}
      callTypes={callTypes}
    />
    <ReactTable
      columns={TIME_SUMMARY_COLUMNS}
      data={calls}
      showPagination={false}
      pageSize={calls.length}
    />
  </div>
);

TimeSummaryItem.propTypes = {
  customer: PropTypes.string,
  calls: PropTypes.array,
  callTypes: PropTypes.object
};

export default TimeSummaryItem;
